import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { useTTUSUserSelective } from '../../../utils/user'
import { deepClone } from '../../../utils/clone'

const HealthStatusServiceAggregator = ({ data }) => {

    const [idFilter, setIdFilter] = useState([])
    const userLookup = useTTUSUserSelective(idFilter)

    const tab_col = [
        {
            field: "user_id",
            headerName: "User ID",
            minWidth: 150,

        },
        {
            field: "email",
            headerName: "Email",
            minWidth: 250,
        },
        {
            field: "account",
            headerName: "Account",
            minWidth: 150,

        },
        {
            field: "source",
            headerName: "Source",
            minWidth: 150,

        },
        {
            field: "order_id",
            headerName: "Order ID",
            minWidth: 150,

        },
    ]
    const [tab_data, settab_data] = useState([])
    useEffect(() => {
        let temp_ids = []
        settab_data(Object.keys(data).reduce((rowData, rowId) => {

            const row = deepClone(data[rowId])

            let order = {}

            for (order of row.order_ids) {

                const emailId = row.user_id && userLookup[row.user_id] ? userLookup[row.user_id].email : '-'
                rowData.push({
                    'uniqueId': order.order_id,
                    'user_id': row.user_id,
                    'email': emailId,
                    'account': order.info.split(",")[0].split("Account=")[1],
                    'source': order.info.split(",")[1].split("Source=")[1],
                    'order_id': order.order_id,
                })
                temp_ids.push(row.user_id)

            }
            setIdFilter(temp_ids)

            return rowData
        }, []))
        return () => {
            settab_data([])
        }
    }, [data, userLookup])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> User Orders </Text>

            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="HealthStatusServiceAggregator"
                tableHeight={700}
            />

        </Box>
    )
}

export default HealthStatusServiceAggregator
